import { createSelector } from "@reduxjs/toolkit";

const getLanguageStore = (state) => state.language;

export const getLocale = createSelector(getLanguageStore, (language) => language.locale);

export const getMessages = createSelector(getLanguageStore, (language) => new Map(JSON.parse(language.messages)).get(language.locale));
